import type { QueryKey } from '@tanstack/react-query'

/**
 * `placeholderData` that keeps the last page on screen while the next one
 * loads, like `keepPreviousData`, but only from a query under `scope` (the
 * same organization and mode). After a switch the new scope shows its own
 * loading state instead of the old one's rows.
 */
export function keepPreviousWithin(scope: QueryKey) {
  return <T>(previous: T | undefined, previousQuery: { queryKey: QueryKey } | undefined): T | undefined =>
    previousQuery !== undefined && scope.every((part, index) => Object.is(previousQuery.queryKey[index], part)) ? previous : undefined
}
